export default __webpack_public_path__ + "static/media/readmegenerator.9141ff9e.png";